import { create } from "zustand";

export const useDockStore = create(set => ({
	mousePosX: null,
	setMousePosX: (pos: number | null) => set({ mousePosX: pos }),
}));
